import React from 'react';

const PlusIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g fill='currentColor'>
        <path
          d='M16 8c.552 0 1 .448 1 1v5.999L23 15c.552 0 1 .448 1 1s-.448 1-1 1h-6v6c0 .552-.448 1-1 1s-1-.448-1-1v-6H9c-.552 0-1-.448-1-1s.448-1 1-1h6V9c0-.552.448-1 1-1z'
          transform='translate(-437.000000, -16.000000) translate(389.000000, 16.000000) translate(48.000000, 0.000000)'
        />
      </g>
    </g>
  </svg>
);

export default PlusIcon;
